import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuth } from "@/contexts/AuthContext";

interface GoogleSignInButtonProps {
  className?: string;
  text?: string;
  disabled?: boolean;
}

export default function GoogleSignInButton({
  className = "",
  text = "Sign in with Google",
  disabled = false,
}: GoogleSignInButtonProps) {
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);

  const login = useGoogleLogin({
    flow: "implicit", // or 'auth-code' if you prefer that flow
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      setError(null);
      try {
        // This contains the access_token
        await loginWithGoogle(tokenResponse); // Your function should extract tokenResponse.access_token
      } catch (err) {
        setError(err instanceof Error ? err.message : "Sign in failed");
        console.error("Sign in error:", err);
      }
    },
    onError: () => {
      setError("Google sign in was cancelled or failed");
    },
  });

  return (
    <div className="flex flex-col items-center">
      <button
        onClick={() => login()}
        className={`bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded shadow-sm hover:bg-gray-100 flex items-center space-x-2 ${className} cursor-pointer`}
        disabled={disabled}
      >
        <img
          src={require('@/assets/g-logo.png')}
          alt="Google logo"
          className="w-5 h-5"
        />
        <span>{text}</span>
      </button>

      {error && (
        <div className="mt-2 text-sm text-red-600 max-w-xs text-center">
          {error}
        </div>
      )}
    </div>
  );
}
